import { createElementBlock as o, openBlock as c, createElementVNode as e } from "vue";
import r from "./index289.js";
const n = {}, l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(a, t, p, m, d, f) {
  return c(), o("svg", l, t[0] || (t[0] = [
    e("path", {
      fill: "currentColor",
      d: "M8 2.25c3.142 0 5.75 1.043 5.75 2.75v3a.75.75 0 0 1-1.493.102L12.25 8V6.92c-1.056.534-2.578.83-4.25.83-1.672 0-3.194-.296-4.25-.83v2.065L3.752 9c0 .503 1.868 1.25 4.25 1.25a.75.75 0 1 1 0 1.5c-1.673 0-3.194-.296-4.251-.83v2.056l.001.024c0 .503 1.868 1.25 4.249 1.25a.75.75 0 1 1 0 1.5c-1.672 0-3.193-.296-4.25-.83V17c0 .503 1.869 1.25 4.25 1.25a.75.75 0 1 1 0 1.5c-3.142 0-5.75-1.043-5.75-2.75V5c0-1.707 2.608-2.75 5.75-2.75Zm10.773 11.5a.75.75 0 0 1 .102 1.493l-.102.007h-7a.75.75 0 0 1-.102-1.493l.102-.007h7ZM8 3.75c-2.381 0-4.25.747-4.25 1.25S5.619 6.25 8 6.25c2.3 0 4.12-.697 4.243-1.197l.005-.038.001-.015v-.01C12.227 4.488 10.367 3.75 8 3.75Z"
    }, null, -1)
  ]));
}
const v = /* @__PURE__ */ r(n, [["render", s]]);
export {
  v as default
};
